import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpCode } from 'types';
import { HttpError } from 'utils/http-error';
import { ModelJson } from '../types';
import { getModel } from './api';

type InitialState = { isError: boolean; data: ModelJson | null; errorCode: HttpCode | null };

const initialState: InitialState = { isError: false, data: null, errorCode: null };

const fetchModelThunk = createAsyncThunk('pageModel/FETCH_MODEL', getModel);

const { actions, reducer } = createSlice({
  name: 'pageModel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelThunk.pending, (state) => {
        state.data = null;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchModelThunk.fulfilled, (state, { payload }) => {
        state.data = payload as ModelJson;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchModelThunk.rejected, (state, { payload }) => {
        throw new HttpError(payload as HttpCode);
      });
  },
});

export { actions, reducer, fetchModelThunk };
